import LoginSectionComponent from '../components/loginSection/LoginSection.Component';

const LoginPageComponent = () => {
  return <LoginSectionComponent />;
};

export default LoginPageComponent;
